import {
  USERS_FETCH,
  USERS_IS_FETCING,
  USERS_API,
  USER_EDIT,
  USERS_FILTER,
} from 'constants/users'
import {
  danger,
} from 'actions/notification'

//HTTP reuests actions
import {
  put,
  post,
  get,
  remove
} from 'actions/requests'



export const usersLogin=(login,password)=>(dispatch)=>{
  dispatch(usersIsFetching(true))
  return post(USERS_API,{
    login,
    password
  })
    .catch((e)=>{ dispatch(danger('Server error('+e+')')) })
    .then((e)=>(e.error?Promise.reject(e.error):e))
    .catch((e)=>{ dispatch(danger('Wrong Details('+e+')',3)) })
    .then(()=>dispatch(usersIsFetching(false)))
}

export const usersave = (id) => (dispatch,state)=>{
  const user=state().users.list[id]
  let action
  if(id===0)
    action=post;
  else 
    action=put
  dispatch(usersIsFetching(true))
  return action('v2/users'+((id===0)?'?password='+encodeURIComponent(user.password):'/'+id),user)
          .then((e)=> {
            dispatch(userFetch({}))
            return e
          })
          .catch((e) => {
            dispatch(usersIsFetching(false))
            throw new Error(e)
          })
}

export const userUpdatePassword = (id) => (dispatch,state)=>{
  dispatch(usersIsFetching(true))
  const user=state().users.list[id]
  return put(USERS_API+'/'+id+'?password='+encodeURIComponent(user.password),{})
          .then((e)=> {
            dispatch(userFetch({}))
            return e
          })
          .catch((e) => {
            dispatch(usersIsFetching(false))
            throw new Error(e)
          })
}

//Feth all users
export const myUserFetch = (id)=>(dispatch,state)=>{
 dispatch(usersIsFetching(true));
        return get(USERS_API + '/' + id)
            .finally(e => dispatch(usersIsFetching(false)))
}


//Feth all users
export const userFetch = ()=>(dispatch,state)=>{
  dispatch(usersIsFetching(true))
  const filter = state().users.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        };
  return get(USERS_API,params)
    //Array->Obj[userId]{...userinformation}
    //for easy access of user by his id
    .then((e)=>{
      dispatch(usersFetched(e.content))
      return e;
    }
      /*usersFetched(
        e.content.reduce(
          (obj,el)=>({
            ...obj,
            [el.userId]:{...el}
          }),{}
        )
      )*/
    )
    .then((e) => {
            dispatch(
                userFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
    //disable loading
    .then((e)=>dispatch(usersIsFetching(false)))
}

export const usersFetchHelper = ()=>(dispatch,state)=>{
  let params = {
    size: 100000,
  }
  return get(USERS_API,params)
    .then((e)=>{
      return e.content
    })
}

export const userRemove = (id) => (dispatch, state) => {
  dispatch(usersIsFetching(true))
  return remove(USERS_API + '/' + id)
      .finally(e => dispatch(usersIsFetching(false)))
}

export const linkUserToIb = (data) => (dispatch) => {
  dispatch(usersIsFetching(true))
  const ibid = Number(data.linkedIbId)
  return put(`${USERS_API}/${data.userId}/ib?ibid=${ibid}`)
    .then((e)=>userFetch({}))
    .then((e)=>dispatch(usersIsFetching(false)))
}

export const unlinkUserToIb = (data) => (dispatch) => {
  dispatch(usersIsFetching(true))
  const ibid = Number(data.linkedIbId)
  return remove(`${USERS_API}/${data.userId}/ib?ibid=${ibid}`)
    .then((e)=>userFetch({}))
    .then((e)=>dispatch(usersIsFetching(false)))
}

export const usersFetched = (payload) => ({type:USERS_FETCH, payload:payload})
export const usersIsFetching = (payload) => ({type:USERS_IS_FETCING,  payload:payload})
export const userFilter = (data) => ({ type: USERS_FILTER, payload: data })
export const userEdit = (id,data) => ({type:USER_EDIT, payload:{id:id,data:data}})



// WEBPACK FOOTER //
// ./src/actions/users.js